declare const currencyCodeBrand: unique symbol;

/**
 * An ISO 4217 code ("EUR"), never a symbol ("€"): what `Intl.NumberFormat({ style: "currency" })`
 * expects. Use `currencyPattern` where a bare symbol is needed.
 */
export type CurrencyCode = string & { readonly [currencyCodeBrand]: true };

/**
 * Asserts an ISO 4217 code without checking it. An invalid code survives to
 * `Intl.NumberFormat`, which throws a RangeError.
 */
export const asCurrencyCode = (value: string): CurrencyCode => value as CurrencyCode;
